// src/components/BarterfiPullLoader.js
import React from 'react';
import './BarterfiPullLoader.css';

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

export default function BarterfiPullLoader({
  progress = 0,
  spinning = false,
  size = 72,
}) {
  const p = clamp(progress, 0, 1);

  // While dragging:
  // - fade in
  // - rotate slowly clockwise
  // - settle upward a little as user pulls more
  const dragRotate = p * 220;
  const opacity = spinning ? 1 : 0.16 + (p * 0.84);
  const scale = spinning ? 1 : 0.84 + (p * 0.16);
  const translateY = spinning ? 0 : (1 - p) * 8;

  return (
    <div
      className={`bf-pull-loader ${spinning ? 'is-spinning' : ''}`}
      style={{
        width: size,
        height: size,
        opacity,
        transform: `translateY(${translateY}px) scale(${scale})`,
      }}
      aria-hidden="true"
    >
      <div
        className="bf-pull-spinner"
        style={{
          width: size,
          height: size,
          transform: spinning ? undefined : `rotate(${dragRotate}deg)`,
        }}
      />
    </div>
  );
}
